import '../css/footer.css';

import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import React from 'react';
import Row from 'react-bootstrap/Row';

export default function Footer() {
  return (
    <>
      <footer className='py-md-2'>
        <Container fluid className='pb-4'>
          <Row className='text-center align-items-center justify-content-between'>
            <Col lg={12} className="mt-2 mb-2">
              <p className='bottomlink mb-0 text-white'>
                <a href='https://swmc.com/privacy-policy' rel='noopener noreferrer' target='_blank'>
                  Privacy Policy
                </a>{' '}
                |{' '}
                <a
                  href='https://swmc.com/terms-and-conditions'
                  rel='noopener noreferrer'
                  target='_blank'>
                  Terms and Conditions
                </a>{' '}
                |{' '}
                <a href='https://swmc.com/disclaimer' rel='noopener noreferrer' target='_blank'>
                  Licenses
                </a>
              </p>
              <div id='callMeFooterLine' />
            </Col>
            <Col lg={12} className="mb-2">
              <a
                title='Like us on Facebook!'
                style={{ margin: '0 5px' }}
                href='https://www.facebook.com/SunWestMortgage'
                target='_blank'
                rel='noopener noreferrer'>
                <img
                  src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAABmJLR0QA/wD/AP+gvaeTAAAEA0lEQVRogd2azWtcVRjGf881qG1taYugKIrxo+lCElFp09hFVBCFFF0ouLD9IxRBVBQXpeB30S7EjQi60ZUoglZtxLa2kbZxoVRpa1SwqE2NNv0yyePiztTJ5N6byb3nzFR/MMxkzjnv+z73Ts5533dGBMT2amAQ6ANWAdcAK4BLalNOAOPAGHAQGAV2SDoYMo5K2L7J9ou2f3Z5frL9gu2+TomQ7Q22d1cQkccu20O21S4xa2yPRBDSzB7bt8YUssj2K7an2yCmzrTtrbYvDi2mx/ZoG4U0s9/2DaHErLX9ewfF1Bm3vb6qmHtsn+ywkEYmbd9dFHPuTmK7H9gOLKl0VcJzCrhL0hdZg5mCbPcAXwLLIwZWhXGgX9L3zQNzBNleRCqmN2JAv5BmC8eB08BS4MLa8+XAZUAyj439wICk04WzbL8a6fN/1PZjbmG3sv1GizZfns/QGsc5Z950eudbYgGCpmzf3Lg2aTAiYBvz3+qFslXSJkmnAtsFuADY5oY0qTH4ISB0qrEHeDSwzWb6gXNbeaOgxyM4e1rS3xHsNvNk/UUXpCUAqdKQfAd81MpE28uZveNetEBfA7Z7JX1dv0ObFmigFbZLct6g7cW2X7c9Sbp9jzc8Hizhb2Oj8SrFWR4bC5xj+7XA/sYAEqdl85Ulrsh8HCkQswx4KLC/q21fn5D2AGIwUTA2CCyO4POOhLShEYM/C8auiOSzLwF6IhmfKRhbEclnTwJ0RzJeROhspE53AiyLZLwTLEv4twn4f2CpbJ8hrUXK8D75h/KEpMz/I6ddnKLs+0NgbYl4znYBJykv6Kyk4wtdVCvKcgsz29eVjOevBPij5OIo2F4JXFpy+URCwYneIVZXWHsoAeY0GjpMlXPxUAJ8FSqSQFS5QyNdwM4KBpbYvjZn7EdJU1kDTuuflTnrqqRiO+tfjYwFTuVt+6o8r7afiODviG0ltSLs3QpX5XzhHUmu51RvdTSUMLwNtSRR0j4gs1f8H2GHpAMwO+t9rkPBhOD5+otzgiS9R7Udr1N8LumD+h/NdcnDwHR746nENPBI4xuzBEnaC7zUzogq8qykWYlBVuX4FHCgPfFUYh/wTPObcwTVmur3Ab+1IaiyHAPul3SmeSCztpc0RipqMnJgZTgBbJCUWSXkNisk7QLuJS0AzxcmgSFJu/MmFHZfJH1C2hT8NXBgZTgKDEoaLpo0bztJ0giwjs6WGXuBdc07WhYt9cckHQZuI80mMkuCSEwBW4D1kn6I4sF2r+3hNpQPn9m+MYqInKDutP2p7ZmAgmZsf2z79rYJyQhule0ttr+pIOhb25sd4AdKQX9kZ7sbGABuATZLOpYz7wHSr0BHgeHauReEfwBdOEQgVhqkhAAAAABJRU5ErkJggg=='
                  alt='Facebook Like Icon'
                  height='25'
                />
              </a>
              &nbsp;
              <a
                title='Follow us on Twitter!'
                style={{ margin: '0 5px' }}
                href='https://www.twitter.com/SunWestMortgage'
                target='_blank'
                rel='noopener noreferrer'>
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAA9CAYAAAD1VdrqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPmSURBVHgB7ZqBddsgEEDPfR3AG0Qb1BtUnSDZIMkEdieQOoG9QZIJ3EygdAKnE+BOYG9wParjcVZlCxCSnPf47/FIMJw44E5wAiCRSCQSicRHZQYDg4hzyu4ofaGUUVpwLtlzeqf0S+ez2WwPAzKI4qxsTmnJueEIVskjl805LTg3vFF6pgF4gY8AKb2idMAanVeU7indOLTNKD1Q2qJF6fZwrVDncu6kUbjgmQ+VZwZBiQHI4JqgDpWxFD4jvxAroISp0QqKZbkbckZ4BZjZ38YeXJ+OzFlZzRpGQj9LDPT4ygulCxgZsfR3MCb0wM1USos+FKOuNva0/+wMJkb4lxUMiXAwV/FqYT+j+G2S+bT9DH7opZ1RemhuKdnRLC+0/U1tfoInDbkv8rn095F+f6Q/K+7bI8SGZ1vzdKHOGs/jPSuNN0dxoV7FdXKIjVaYhWdwuaOK691TuuF0y2UKPV5BwoaLjnp516QEIWa7cqx7aCqJ9R5e4+SFqd6zZ/2Knxvv3Y7WkzsdFoSSVUvnNKuO9qXvDIo+LiEWosM+y3TdVBIdvLBQ2mtzwrIP6LAqfYR6C8RTe89FeX7O3qXSGLBkzXKHGJCgBTo4mDNtne1dlCkM3COIVdZ59ncRdsfCbiEAF3sX9hmsNMt86NPXprAlC/sKgTjY+wEj7AaFGfWP2KA9DAQvH+y2d80CeoL2tdtplp9gBPTWkrJvUAcYn4y9U/kbZd+52qhxtVEU1/Ae+wfUe/2tKN9AHVFd4dCnLB9i2HhDXtD73VG2MZ3OTYzLjP/hPIOeoI23a9bG3tkU9MlK/15h+LbTtNtDX4TD6B3pQBGjwwj7+Rb5RSxHaQT23gqiPXQU/H/X+93b2WHMnZsUGLoE0cbonhrlzy32noXYO/sJTbyQmHBwIbNQnusQnr7fF6LcOCnnPTt6niCdwMCTDzocOrA+C7TZe+Fj78JEMogJ2ghM7ljfKK2wY9aEvW8b5ZXLLKJDWCwYsfxcojDeh44+9o4OYbFeuMw62mOsQn/npLits72LQY4/2+Ihredr8bu01ww8Ee2NDCUGQ7Nu6Y8KfZ5v587Z45xtUmGPDQTLVxfSnahrorDjHHDQ7rdLmAi0znO0L7XmwbuplMfAgGSsh0/1fXxzydmN1Ql5I0Lh8DcizEBPdyOi0akCLSVEhAe3RHuTarJv8q3g6R0Vnd9jv6BCU2EtM0owZBDw9IqWWZZOg4D2ileFp3fl4n0WYga70qkVgDqAmItiHWl55/zIZdpWM07Nm40bis68wgCMcZc1g/oeaw72HmvWqLaHekBM/srhqEQikUgkEon/+AtkijqmmV3npwAAAABJRU5ErkJggg=="
                  alt='Twitter Icon'
                  height='35'
                />
              </a>
              &nbsp;
              <a
                title='Follow us on LinkedIn!'
                style={{ margin: '0 5px' }}
                href='https://www.linkedin.com/company/sun-west-mortgage-company/about/'
                target='_blank'
                rel='noopener noreferrer'>
                <img
                  src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAABmJLR0QA/wD/AP+gvaeTAAACdElEQVRoge2Zz4tNYRjHP89NjGFGGKEs/MhisDMUhULKYiz8KJmVnR1ZkJ2tGv4AmRoLiylJspDsJI2EQvlRYyHJSGqSdOV+Le490+vOvee+rznd98ztfFbPec/zvD2fzj3vfc85UFDQVqx+QNJ84CgwCPQD3cAkMA6MmtnLtnY4GyT1S3qt5lQkXZFUit1rSyStkPQ5RcZlOHa/LZE07CkjSX8krY/dcyPcn86BwLrBjHvJBFeoN7C2L8tGssIVehtY+ybLRjJH0pGAe+iLpJ7YPbdE0oiHTFnSwdi9eiGpJOm0pMkmMs8k7YjdZxozdgoAkrqAXcBmYDHwFRg3sxdt7K0AnCskaQuw07OuDNw0sx+1WgMOA8s96yfM7EH9oKQ1wFpgJbAU+A58AF6ZWdlz7unJJgJWOUm66NTuD6yt1JpH0jpJl5S+h5ySdEPS1lYe7v9Q6DLc2yT2wYANkq4D74FzwKaU/B7gBPBE0mVJC5slzgtsJEvuAV2BNSXgLLBb0j4zm2qUEItQGZcB4I6qq/E/5P+5pjl7gAv1g3NZCOC8pI3uwFwXWgCccQfmuhDAkKTu5KAThJYAe5ODThAC2J4EMYUEjALbqN4LfcBx/u/BcSAJYgqdMrOTZvbUzMpm9s3MxqgKPgyca1USxBK6ZWZXG52obXiHgF8B8y1LglhCI2knzewjcD9gvkVJEEvonUdO6EsbIJ7Qb4+csOefGp2ybE9TCOWdQijvFEJ5pxDKO4VQ3imE8k5HCymwVk3i0NrZ5MzIdV/WXwOO4XfVfgK3nePHwCNgtUftc+CTR95d4BDVL4hpVIAxj/kKCgo8+AuAHwTPGUGp9QAAAABJRU5ErkJggg=='
                  alt='LinkedIn Icon'
                  height='25'
                />
              </a>
              &nbsp;
            </Col>

            <Col lg={12} className='text-white'>
              <p className='footerYear'>
                &copy; {new Date().getFullYear()} Sun West Mortgage Company, Inc. All Rights
                Reserved
              </p>
              <p>
                For licensing information, go to:{' '}
                <a
                  href='https://www.nmlsconsumeraccess.org/EntityDetails.aspx/company/3277'
                  className='external-link'
                  target='_blank'
                  rel='nofollow'
                  title='NMLS Consumer Access'
                >
                  nmlsconsumeraccess.org
                </a>
                . Visit{' '}
                <a
                  href='https://www.swmc.com/disclaimer'
                  target='_blank'
                  className='external-link'
                  rel='nofollow'
                  title='Click here for full list of license information of Sun West Mortgage Company, Inc.'>
                  https://www.swmc.com/disclaimer
                </a>{' '}
                for the full list of license information.
              </p>
              <p>  Please{' '}
                <a href="https://www.swmc.com/TXdis"
                  target='_blank'
                  rel='noopener noreferrer'
                  title="View Texas Complaint Notice and Servicing Disclosure" >
                  <b>Click Here</b>
                </a>{' '}
                to view Texas Complaint Notice and Servicing Disclosure. </p>

            </Col>
            <Row className='pt-2 pb-5 d-flex justify-content-center text-center'>
              <Col xs={12} lg={2} xl={2} className='mb-2' style={{ paddingTop: '20px' }}>
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://sunwestmortgage.com/'
                  className='mb-3'>
                  <Image
                    src='https://resources.swmc.com/swmc-images/minified/Top-50-Logo-blue.png'
                    alt='Mortgage Executive Top 50 logo'
                    title='Mortgage Executive Top 50'
                    style={{ height: '175px' }}
                  />
                </a>
              </Col>
              <Col xs={12} lg={3} xl={2} className='mb-2' style={{ paddingTop: '20px' }}>
                <a
                  target='_blank'
                  rel='noopener noreferrer'
                  href='https://www.bbb.org/us/ca/buena-park/profile/mortgage-banker/sun-west-mortgage-company-inc-1126-172020499'
                  className='mb-2'>
                  <Image
                    src='https://resources.swmc.com/swmc-images/minified/bbb-white.png'
                    alt='BBB accredited business'
                    style={{ height: '60px' }}
                  />
                </a>
                <div style={{ paddingTop: '20px' }}>
                  <a
                    href='https://www.checkbca.org/report/sun-west-mortgage-company-inc-59000209'
                    target='_blank'
                    rel='noopener noreferrer'>
                    <img
                      src='https://resources.swmc.com/swmc-images/Footer/swmc/Bcawidgets.png'
                      alt='Bca logo'
                    />
                  </a>
                </div>
              </Col>
              <Col xs={12} lg={3} xl={2} style={{ paddingTop: '20px' }}>
                <Image
                  src='https://resources.swmc.com/swmc-images/Footer/equal-housing.png'
                  alt='Equal Housing Opportunity'
                  title='Equal Housing Opportunity logo'
                  className='mb-3'
                  style={{ height: '75px' }}
                />
                <div>
                  <script
                    type='text/javascript'
                    src='https://birdeye.com/embed/v4/154827373198858/5/2709571098'></script>
                  <div
                    id='bf-revz-widget-2709571098'
                    style={{
                      textAlign: 'center',
                      WebkitOverflowScrolling: 'touch',
                    }}>
                    <iframe
                      name='bfiframe'
                      src='https://birdeye.com/widget/render.php?bid=154827373198858&amp;wid=5&amp;ver=4&amp;update=0'
                      id='bfpublish'
                      scrolling='no'
                      style={{
                        border: '1px solid transparent',
                        borderRadius: '8px',
                        display: 'block',
                        margin: '0px auto',
                        overflow: 'hidden',
                        width: '145px',
                        height: '75px',
                      }}
                      frameBorder='0'></iframe>
                    <div
                      className='bf-dv'
                      style={{
                        fontFamily: '&quot;roboto&quot, sans-serif',
                        margin: '0px auto',
                        width: '145px',
                        color: 'rgb(102, 102, 102)',
                        backgroundColor: 'transparent',
                        display: ' table',
                        height: '25px',
                      }}>
                      <span
                        className='bf-spn text-white'
                        style={{
                          fontSize: '12px',
                          lineHeight: '12px',
                          width: 'auto',
                          display: 'table-cell',
                          verticalAlign: 'middle',
                        }}>
                        powered by{' '}
                        <a
                          className='bf-pwr'
                          href='https://birdeye.com/?utm_source=development.swmc.com&amp;utm_medium=widget_review-badge&amp;utm_campaign=birdeye_widget&amp;utm_term=powered-by-birdeye&amp;utm_content=customer-reviews_rectangle_#51a8d3'
                          target='_blank'
                          rel='noopener noreferrer'
                          style={{
                            color: 'rgb(81, 168, 211)',
                            textDecoration: 'none',
                          }}>
                          BirdEye
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Row>
        </Container>
      </footer>
    </>
  );
}
